function splitioPlugin(userConfig = {}) {
  return {
    NAMESPACE: 'splitio',
  }
}

export default splitioPlugin
